import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'src/store/redux';
import {
  sanitizeInsightThumbnailUrl,
  sanitizeInsightUrl,
} from 'src/utils/url.utils';

import { Feedback, Score } from './types';

const sanitizeFeedbackInsight = (feedback: Feedback): Feedback => {
  return {
    ...feedback,
    insight_content: {
      ...feedback.insight_content,
      url: sanitizeInsightUrl(feedback.insight_content.url),
      thumbnailURL: sanitizeInsightThumbnailUrl(
        feedback.insight_content.thumbnailURL,
      ),
    },
  };
};

const sanitizeScoreInsight = (score: Score): Score => {
  return {
    ...score,
    insight_content: {
      ...score.insight_content,
      url: sanitizeInsightUrl(score.insight_content.url),
      thumbnailURL: sanitizeInsightThumbnailUrl(
        score.insight_content.thumbnailURL,
      ),
    },
  };
};

export const insightsApi = createApi({
  reducerPath: 'insights',
  baseQuery: baseQuery('insights'),
  refetchOnMountOrArgChange: false,
  endpoints: (builder) => ({
    getFeedback: builder.query<Feedback[], string>({
      query: (userBk) => ({
        url: `find`,
        method: 'POST',
        body: {
          insight_type: 'teacher-feedback',
          user_keys: [userBk],
        },
      }),
      transformResponse: (response: Feedback[]) =>
        response.map(sanitizeFeedbackInsight),
    }),
    getScore: builder.query<Score[], string>({
      query: (userBk) => ({
        url: `find`,
        method: 'POST',
        body: {
          insight_type: 'teacher-score',
          user_keys: [userBk],
        },
      }),
      transformResponse: (response: Score[]) =>
        response.map(sanitizeScoreInsight),
    }),
  }),
});

export const { useGetFeedbackQuery, useGetScoreQuery } = insightsApi;
